<!--预付费表管理 tableManagement-->
<template>
  <div class="tableManagementBody">
    <!--头部选择框-->
    <div class="tableManagement_from">
      <el-form label-width="90px" style="display: flex;align-items: center;">
        <el-form-item label="设备名称">
          <el-input v-model="tableFrom.deviceName" placeholder="请输入设备名称" maxlength="20" style="width:160px;"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="表类型">
          <el-select v-model="tableFrom.type" placeholder="请选择" clearable @change="getInitData()">
            <el-option v-for="item in tableTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="padding-left: 35%;">
          <el-button type="primary" size="mini" @click="search">查询</el-button>
          <el-button type="primary" size="mini" @click="addShow = true">新增表</el-button>
          <el-button type="primary" size="mini" @click="getQRcode()">导出二维码</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableManagement_table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="90" label="序号"> </el-table-column>
        <el-table-column prop="name" label="名称" width="180">
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期" width="150" :formatter="formatTime">
        </el-table-column>
        <el-table-column prop="deviceName" label="绑定设备"> </el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <span v-show="scope.row.type == 'coldWater'">冷水表</span>
            <span v-show="scope.row.type == 'hotWater'">热水表</span>
            <span v-show="scope.row.type == 'electric'">电表</span>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余量"></el-table-column>
        <el-table-column prop="unit" label="单位"> </el-table-column>
        <el-table-column prop="rate" label="单价"></el-table-column>
        <el-table-column prop="amount" label="金额(元)"> </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editMangement(scope.row)" plain>编辑</el-button>
            <el-button size="mini" type="primary" @click="refund(scope.row)" plain>退费</el-button>
            <el-button size="mini" type="danger" @click="deleteMangment(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <div style="margin-top: 10px;width: 20%;">
        <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
    </div>
    <el-dialog title="新增表" :visible.sync="addShow" customClass="customWidth">
      <div class="dialog_from">
        <el-form :model="dialogFrom" ref="dialogFrom">
          <el-form-item label="表类型" :label-width="formLabelWidth" required prop="type"
            :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]">
            <el-select v-model="dialogFrom.type" placeholder="请选择" style="width:100%">
              <el-option v-for="item in tableTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="表名称" :label-width="formLabelWidth" required prop="tableName"
            :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]">
            <el-input v-model="dialogFrom.tableName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="单价(元)" :label-width="formLabelWidth" required prop="rate"
            :rules="[{ required: true, message: '不能为空', trigger: 'blur' },{ type: 'number', message: '必须为数字值'}]">
            <el-input :min="0" v-model.number="dialogFrom.rate" autocomplete="off"> </el-input>
          </el-form-item>
          <el-form-item label="绑定设备" :label-width="formLabelWidth" required>
            <el-input v-model="bindDevice.label" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-device">
        <electricMeterTree :dataList="deviceListFilter" @checkItem="checkItemList"></electricMeterTree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="upShow" customClass="customWidth">
      <div class="dialog_from">
        <el-form :model="updialogFrom" ref="updialogFrom">
          <el-form-item label="表类型" :label-width="formLabelWidth" required prop="type"
            :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]">
            <el-select v-model="updialogFrom.type" placeholder="请选择" style="width:100%">
              <el-option v-for="item in tableTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="表名称" :label-width="formLabelWidth" required prop="name"
            :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]">
            <el-input v-model="updialogFrom.name" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="单价(元)" :label-width="formLabelWidth" required prop="rate"
            :rules="[{ required: true, message: '不能为空', trigger: 'blur' },{ type: 'number', message: '必须为数字值'}]">
            <el-input :min="0" v-model.number="updialogFrom.rate" autocomplete="off"> </el-input>
          </el-form-item>
          <el-form-item label="绑定设备" :label-width="formLabelWidth" required>
            <el-input v-model="bindDevice.label" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-device">
        <electricMeterTree :dataList="deviceListFilter" @checkItem="checkItemList"></electricMeterTree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="update" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <!--退费弹窗-->
    <el-dialog title="退费" :visible.sync="refundShow" style="width:60%;margin:0 auto;">
      <el-form :model="refundForm">
        <el-form-item label="密码" :label-width="formLabelWidth" required>
          <el-input v-model="confirmPassword" type="password" autocomplete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="表名" :label-width="formLabelWidth">
          <el-input v-model="refundForm.name" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="绑定设备" :label-width="formLabelWidth">
          <el-input v-model="refundForm.deviceName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="退费金额(元)" :label-width="formLabelWidth" required>
          <el-input v-model="refundForm.refundAmount" type="number" class="numberInput" autocomplete="off"
            :placeholder="refundPlace"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refundShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmRefund" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import elPagination from "@/components/module/elComponents/elPagination.vue";
  import electricMeterTree from "@/components/module/meterReading/electricMeterTree.vue";
  export default {
    components: {
      electricMeterTree,
      elPagination,
    },
    props: {},
    data () {
      return {
        pageSize: 20,
        total: 0,
        pageIndex: 1,
        tableData: [],
        formLabelWidth: "120px",
        tableTypeList: [
          {
            label: "电",
            value: "electric",
          },
          {
            label: "冷水",
            value: "coldWater",
          },
          {
            label: "热水",
            value: "hotWater",
          },
        ],
        tableFrom: {
          deviceName: "",
          type: "",
        },
        dialogFrom: {
          tableName: "",
          type: "",
          unit: "",
        },
        updialogFrom: {
          tableName: "",
          type: "",
          unit: "",
        },
        bindDevice: {label: ""}, //绑定的设备
        addShow: false,
        upShow: false,
        refundShow: false,
        bindDevicesList: [],
        refreshInterval: 300000,//五分钟
        refundForm: {
          deviceName: '',
          name: '',
          refundAmount: '',
          userId: '',
        },
        refundPlace: "",
        selectBalance: "",//当前的金额
        confirmPassword: '',//密码
      };
    },
    created () {},
    mounted () {
      this.getInitData();
      //五分钟获取一次列表余量
      addNewTask('getFindDataByPage',1000,this.refreshInterval,-1,() => {
        this.getInitData();
      });
    },
    destroyed () {
      removeTask('getFindDataByPage');
    },
    computed: {
      //过滤已绑定的设备
      deviceListFilter () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree;
        var list=[deviceList(data)]
        var resultList=[]
        var nowList=list[0].children.map((item,index) => {
          if(!this.bindDevicesList.includes(item.id)) {
            resultList.push(item)
          }
        })
        list[0].children=resultList
        return list
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit;
      },
    },
    watch: {},
    methods: {
      formatTime (row,column,cellValue) {
        return new Date(row.createTime).format("yyyy-MM-dd");
      },
      getBindDevices () {
        this.$api.prepaymentApi.getBindDevices((respon) => {
          this.bindDevicesList=copy(respon)
        });
      },
      getInitData () {
        //获取数据
        this.$api.prepaymentApi.getFindDataByPage(
          this.tableFrom.deviceName,
          this.tableFrom.type,
          this.pageIndex,
          this.pageSize,
          (respon) => {
            this.total=respon.total;
            this.tableData=respon.data;
          }
        );
        this.getBindDevices()
      },
      getQRcode () {
        if(isempty(this.nowUnit.id)||isempty(this.nowUnit)) {
          return
        }
        this.$api.prepaymentApi.getQRcode(this.nowUnit.id,(respon) => {
          saveAs(
            DWSystemSetting.downloadUrl+"/"+respon,
            this.nowUnit.name+"设备充值二维码.xls"
          );
        });
      },
      //确认添加
      confirm () {
        this.$refs.dialogFrom.validate((valid) => {
          if(isempty(this.bindDevice)||isempty(this.bindDevice.no)) {
            this.$message({
              type: "error",
              message: "请选择绑定的设备",
            });
            return;
          }
          if(valid) {
            if(this.dialogFrom.type=="electric") {
              this.dialogFrom.unit="kWh";
            } else if(this.dialogFrom.type=="coldWater") {
              this.dialogFrom.unit="m³";
            } else if(this.dialogFrom.type=="hotWater") {
              this.dialogFrom.unit="L";
            }
            this.$api.prepaymentApi.getPrepaymentSave(
              this.dialogFrom.tableName,
              this.dialogFrom.type,
              this.dialogFrom.unit,
              this.dialogFrom.rate,
              this.bindDevice.no,
              respon => {
                if(respon=='保存成功！') {
                  this.$message({
                    message: "添加成功",
                    type: "success",
                  });
                  this.addShow=false
                  this.getInitData()
                }
              },err => {
                this.$message({
                  message: err
                });
                this.addShow=false
                this.getInitData()
              });
          } else {
            return false;
          }
        });
      },
      pageindexChange (index) {
        //当前页
        this.pageIndex=index;
        this.getInitData();
      },
      handleSizeChange (size) {
        //长度变化
        this.pageSize=size;
        this.getInitData();
      },
      //编辑
      editMangement (item) {
        this.updialogFrom=copy(item)
        this.bindDevice=item
        this.bindDevice.label=item.deviceName
        this.upShow=true
      },
      //退费
      refund (val) {
        this.refundForm.deviceName=val.deviceName
        this.refundForm.name=val.name
        this.selectBalance=val.balance
        this.refundPlace='最多可退'+(val.balance/100).toFixed(2)+'元'
        this.refundForm.userId=val.userId
        this.confirmPassword=''
        this.refundForm.refundAmount=''
        if(val.balance==0&&!isempty(val.balance)) {
          this.$message.success('账户余额为0，无需退费')
          return
        } else if(val.balance<0&&!isempty(val.balance)) {
          this.$message.error('用户账户存在欠款，请充值')
          return
        }
        this.refundShow=true
      },
      confirmRefund () {
        if(isempty(this.confirmPassword)) {
          this.$message.error('请输入密码')
          return
        }
        if(isempty(this.refundForm.refundAmount)) {
          this.$message.error('退费金额或者输入格式不对！')
          return
        }
        if(this.refundForm.refundAmount*100>this.selectBalance) {
          this.$message.error('退款金额大于账户余额')
          return
        }
        this.$api.meterReadingApi.refundMeterAmount(this.refundForm.userId,this.refundForm.refundAmount*100,hex_md5(this.confirmPassword),respon => {
          this.$message.success(respon)
          this.getInitData()
          this.refundShow=false
        },err => {
          this.$message({
            type: 'error',
            message: err
          });
        })
      },
      //修改
      update () {
        this.$refs.updialogFrom.validate((valid) => {
          if(valid) {
            if(this.updialogFrom.type=="electric") {
              this.updialogFrom.unit="kWh";
            } else if(this.updialogFrom.type=="coldWater") {
              this.updialogFrom.unit="m³";
            } else if(this.updialogFrom.type=="hotWater") {
              this.updialogFrom.unit="L";
            }
            this.$api.prepaymentApi.getPrepaymentSave(
              this.updialogFrom.name,
              this.updialogFrom.type,
              this.updialogFrom.unit,
              this.updialogFrom.rate,
              this.bindDevice.no? this.bindDevice.no:this.bindDevice.deviceNo,
              this.updialogFrom.id,
              respon => {
                if(!isempty(respon)) {
                  this.$message({
                    message: "修改成功",
                    type: "success",
                  });
                  this.upShow=false;
                  this.getInitData();
                }
              },
              err => {
                this.$message({
                  message: err,
                });
                this.upShow=false;
                this.getInitData();
              }
            );
          } else {
            return false;
          }
        });
      },
      deleteMangment (defectData) {
        //删除
        this.$confirm("此操作将永久删除该信息, 是否继续?","提示",{
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$api.prepaymentApi.getDelete(
              defectData.id,
              (respon) => {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                });
                this.search();
              },
              (err) => {
                this.$message({
                  message: err,
                  type: "error",
                });
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      search () {
        this.getInitData();
      },
      checkItemList (val) {
        //选中的设备
        this.bindDevice=val;
      },
    },
  };
</script>

<style>
  .tableManagementBody .el-dialog__body {
    display: flex;
    justify-content: space-between;
  }

  .customWidth {
    width: 40%;
  }
</style>
<style scoped>
  .tableManagementBody {
    width: 100%;
    height: 100%;
    background-color: white;
  }

  .tableManagement_from {
    margin-top: 1%;
  }

  .tableManagement_table {
    width: 98%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .dialog_from {
    width: 60%;
  }

  .dialog-device {
    height: 400px;
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87cf64;
    border-radius: 4px;
    color: #87cf64;
    background-color: #f0f9ec;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #f9a6a6;
    border-radius: 4px;
    color: #f9a6a6;
    background-color: #fef1f1;
    line-height: 28px;
    padding: 0 6px;
  }
</style>